// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"776":"5c0ac147","975":"406b8683"}[chunkId] + ".chunk.js";
};